import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	genericErrorMessage: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.generic-error-message',
		defaultMessage: 'Atlassian Intelligence (AI) isn’t responding. Try again later.',
		description: 'Generic error message for when Atlassian Intelligence fails to respond.',
	},
	labelRetry: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.label-retry',
		defaultMessage: 'Retry',
		description: 'Retry button for refetch suggested issues from Atlaasian Intelligence.',
	},
	labelCancel: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.label-cancel',
		defaultMessage: 'Cancel',
		description: 'CancelEsc\'s "Cancel" button label.',
	},
	labelEsc: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.label-esc',
		defaultMessage: 'Esc',
		description: 'CancelEsc\'s "Esc" button label.',
	},
	footerTextIsWorking: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-error.footer-text-is-working',
		defaultMessage: 'Atlassian Intelligence is working...',
		description: 'Footer text in the Issue Breakdown when generating child issues.',
	},
});
